export const menuAlterarPf = {
    label: 'Alterar Cadastro SSE',
    icon: 'pi pi-bars',
    rules: ['NAN-PARCEIROSPF-01'],
    to: '/nan/parceiropf/atualizar',
};